namespace Cfnc {
    "use strict";

    interface ISavedColleges {
    }

    interface ISavedCollegesScope extends ng.IScope {
        vm: SavedColleges;
    }

    class SavedColleges implements ISavedColleges {
        static $inject: Array<string> = ["common", "Restangular", "$scope", "$uibModal", "config"];
        static controllerId: string = "savedColleges";
        private log;
        pageNumber: number;
        pageSize: any;
        searchString: string;
        loaded: boolean;
        searchResults: any;
        cardView: boolean;
        minDate: Date;
        filterParams: any;
        interests: any;
        showMap: boolean;
        map: googleMaps.googleMap;
        options: any;
        stateCoords;
        mappingData;
        markers: Array<any>;
        notesOpen: boolean;
        visitNotesOpen: boolean;
        actionsOpen: boolean;
        totalColleges: number;
        editList: any;
        actions: any;
        apiHost: any;
        umbracoUrl: string;
        cfncUrl: string;
        slickConfig: any;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showHowl?) => void;

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $scope: ISavedCollegesScope, private $uibModal: ng.ui.bootstrap.IModalService, private config: IConfig) {
            this.pageNumber = 1;
            this.pageSize = 25;
            this.cardView = true;
            this.searchString = "";
            this.loaded = false;
            this.showMap = false;
            this.minDate = new Date(1899, 12);
            this.markers = [];
            this.notesOpen = false;
            this.visitNotesOpen = false;
            this.actionsOpen = false;
            this.apiHost = config.apiHost;
            this.umbracoUrl = this.config.umbracoUrl;
            this.cfncUrl = this.config.cfncUrl;
            this.slickConfig = {
                slidesToShow: 3,
                dots: false,
                arrows: false,
                centerMode: true,
                infinite: false,
                variableWidth: true,
                focusOnSelect: true
            };

            this.log = common.logger.getLogFn(SavedColleges.controllerId);
            this.logSuccess = this.common.logger.getLogFn(SavedColleges.controllerId, "success");
            this.logError = common.logger.getLogFn(SavedColleges.controllerId, "error");

            this.map = { center: { latitude: 35.250224, longitude: -79.905000 }, zoom: 15, pan: true };
            this.options = { options: { mapTypeId: google.maps.MapTypeId.TERRAIN, streetViewControl: false, zoomControlOptions: { style: google.maps.ZoomControlStyle.SMALL } } };
            this.stateCoords = coords;

            this.actions = [{ id: 1, name: "Visited the Campus" },
            { id: 2, name: "Financial Aid Forms Submitted" },
            { id: 3, name: "Not Admitted" },
            { id: 4, name: "Attended an Application Interview" },
            { id: 5, name: "Admitted" },
            { id: 6, name: "Intend to Enroll" },
            { id: 7, name: "Application Submitted" },
            { id: 8, name: "Wait-listed" },
            ]

            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.activate();
                }
            });
            this.activate();

        }

        activate() {
            var promises = [];
            this.common.activateController(promises, SavedColleges.controllerId)
                .then(() => {
                    this.apiHost = this.config.apiHost;
                    this.getColleges();
                });
        }

        getColleges() {
            var queryParams = { pageNumber: this.pageNumber };
            this.Restangular.one("collegePlanning/getsavedcolleges").get(queryParams).then((results) => {
                this.searchResults = results;
                this.editList = _.cloneDeep(this.searchResults.colleges);
                this.totalColleges = this.searchResults.totalColleges;
                this.loaded = true;
            }, (reason) => {
                this.logError(reason, reason, true);
                this.logError("There was a problem getting your saved colleges. Please try again later.", reason, true);
            });
        }

        mapSingleProgram(program: any) {
            this.markers = this.createSinglePin(program);
            this.map = { center: { latitude: program.latitude, longitude: program.longitude }, zoom: 10, pan: true };
        }

        createSinglePin(program: any) {
            var markers = [];
            var marker = {
                selected: false,
                latitude: program.latitude,
                longitude: program.longitude,
                id: program.id,
                options: {
                    optimized: false,
                    title: program.name,
                    icon: document.location.origin + "/images/blue_pin.png"

                },
                show: false
            };
            markers.push(marker);
            return markers;
        }

        cancelEdit = (originalArray: any, itemToRemove: any, index: number): void => {
            var original = originalArray[index];
            angular.copy(original, itemToRemove);
        };

        checkTrackedAction(actionID: any, collegeActions: any) {
            var found = false;
            for (var i in collegeActions) {
                if (collegeActions[i].questionName == actionID)
                    found = true;
            }
            return found;
        }

        modifyTrackedAction(college: any, action: any) {
            var found = false;
            for (var i in college.actions) {
                if (college.actions[i].questionName == action) {
                    found = true;
                    college.actions.splice(i, 1);
                }
            }
            if (!found) {
                var actionDict = _.keyBy(this.actions, 'name');
                var addedAction = actionDict[action];
                var data = { id: '', organizationID: college.organizationID, questionID: addedAction["id"], questionName: addedAction["name"] };
                college.actions.push(data);
            }
        }

        updateSavedCollege = (savedCollege: any, index: number) => {
            this.Restangular.all("collegePlanning/updateSavedCollege").post(savedCollege).then((results) => {
                this.getColleges();
                this.logSuccess("Your changes have been saved", null, true);
            }, (reason) => {
                console.error(reason);
                this.logError("There was a problem updating the college. Please try again later.", reason, true);
            });
        }

        deleteSavedCollege = (savedCollege: any) => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    this.Restangular.all("collegePlanning/deletesavedcollege").post(savedCollege).then((results) => {
                        this.logSuccess("Saved college removed.", null, true);
                        this.getColleges();
                    }, (reason) => {
                        console.error(reason);
                        this.logError("There was a problem deleting the college. Please try again later.", reason, true);
                    });
                }
            });
        }
    }

    angular.module("app").controller(SavedColleges.controllerId, SavedColleges);

    var coords = [{ latitude: 33.7963, longitude: -78.4850 },
    { latitude: 34.8037, longitude: -79.6742 },
    { latitude: 34.8206, longitude: -80.8003 },
    { latitude: 34.9377, longitude: -80.7880 },
    { latitude: 35.1019, longitude: -80.9377 },
    { latitude: 35.0356, longitude: -81.0379 },
    { latitude: 35.1457, longitude: -81.0324 },
    { latitude: 35.1660, longitude: -81.3867 },
    { latitude: 35.1985, longitude: -82.2739 },
    { latitude: 35.2041, longitude: -82.3933 },
    { latitude: 35.0637, longitude: -82.7765 },
    { latitude: 35.0817, longitude: -82.7861 },
    { latitude: 34.9996, longitude: -83.1075 },
    { latitude: 34.9918, longitude: -83.6183 },
    { latitude: 34.9918, longitude: -84.3201 },
    { latitude: 35.2131, longitude: -84.2885 },
    { latitude: 35.2680, longitude: -84.2226 },
    { latitude: 35.2310, longitude: -84.1113 },
    { latitude: 35.2815, longitude: -84.0454 },
    { latitude: 35.4058, longitude: -84.0248 },
    { latitude: 35.4719, longitude: -83.9424 },
    { latitude: 35.5166, longitude: -83.8559 },
    { latitude: 35.5512, longitude: -83.6938 },
    { latitude: 35.5680, longitude: -83.5181 },
    { latitude: 35.6327, longitude: -83.3849 },
    { latitude: 35.7142, longitude: -83.2475 },
    { latitude: 35.7799, longitude: -82.9962 },
    { latitude: 35.8445, longitude: -82.9276 },
    { latitude: 35.9224, longitude: -82.8191 },
    { latitude: 35.9958, longitude: -82.7710 },
    { latitude: 36.0613, longitude: -82.6419 },
    { latitude: 35.9702, longitude: -82.6103 },
    { latitude: 35.9547, longitude: -82.5677 },
    { latitude: 36.0236, longitude: -82.4730 },
    { latitude: 36.0669, longitude: -82.4194 },
    { latitude: 36.1168, longitude: -82.3535 },
    { latitude: 36.1345, longitude: -82.2862 },
    { latitude: 36.1467, longitude: -82.1461 },
    { latitude: 36.1035, longitude: -82.1228 },
    { latitude: 36.1268, longitude: -82.0267 },
    { latitude: 36.2797, longitude: -81.9360 },
    { latitude: 36.3527, longitude: -81.7987 },
    { latitude: 36.3361, longitude: -81.7081 },
    { latitude: 36.5880, longitude: -81.6724 },
    { latitude: 36.5659, longitude: -80.7234 },
    { latitude: 36.5438, longitude: -80.2977 },
    { latitude: 36.5449, longitude: -79.6729 },
    { latitude: 36.5449, longitude: -77.2559 },
    { latitude: 36.5505, longitude: -75.7562 },
    { latitude: 36.3129, longitude: -75.7068 },
    { latitude: 35.7131, longitude: -75.4129 },
    { latitude: 35.2041, longitude: -75.4720 },
    { latitude: 34.9794, longitude: -76.0748 },
    { latitude: 34.5258, longitude: -76.4951 },
    { latitude: 34.5880, longitude: -76.8109 },
    { latitude: 34.5314, longitude: -77.1378 },
    { latitude: 34.3910, longitude: -77.4481 },
    { latitude: 34.0481, longitude: -77.7983 },
    { latitude: 33.7666, longitude: -77.9260 },
    { latitude: 33.7963, longitude: -78.4863 }];
} 